import React, { useCallback, useState } from 'react';
import { View, FlatList, TouchableOpacity } from 'react-native';
import IconsMap from './IconsMap';
import { tabSwitcherStyle } from '../style';
import { Typography, useTheme } from '@hmsexp/component-library';

const TabSwitcher = props => {
  const { switchOptions, activeOption, onTabChange } = props;
  const theme = useTheme();
  const styles = tabSwitcherStyle(theme);
  const renderItem = ({ item }) => {
    return (
      <TouchableOpacity
        onPress={() => onTabChange(item)}
        style={[styles.tabSwitchItem, activeOption === item && styles.tabSwitchActiveItem]}>
        <IconsMap iconKey={item} />
      </TouchableOpacity>
    );
  };
  return (
    <View style={styles.container}>
      <FlatList
        keyExtractor={item => item}
        extraData={activeOption}
        data={switchOptions}
        horizontal={true}
        renderItem={renderItem}
      />
    </View>
  );
};
export default TabSwitcher;
